<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="error">
        <span class="headline white--text">Gastgeber löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du den Gastgeber "{{ host.forename }} {{ host.surname }} &lt;{{ host.email }}&gt;" wirklich
        löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="remove()" :loading="loading">Löschen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgHostDelete',
    props: ['host'],
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    methods: {
      ...mapActions({
        removeHost: 'admin/hosts/remove',
        readAll: 'admin/hosts/read',
      }),
      remove() {
        this.loading = true;
        this.removeHost(this.host).then((res) => {
          this.loading = false;
          if (res) {
            this.readAll();
            this.dialog = false;
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
